import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { ProjectionLabelComponent } from './projection-label.component';

@NgModule({
  imports: [CommonModule, PipesModule],
  declarations: [ProjectionLabelComponent],
  exports: [ProjectionLabelComponent],
})
export class ProjectionLabelModule { }
